'use client'
import Image from 'next/image'

import { useGlobalContext } from '../context/provider'

import CryptoJS from 'crypto-js'

import FooterDesktop from '../Responsive/footer/FooterDesktop'
import FootLogo from '@/public/EVELogoWhite.svg'
import FootLogoBlack from '@/public/EVElogoBlack.svg'
import FooterTablet from '../Responsive/footer/FooterTablet'
import { AxiosGetData } from '../context/axiosfunction'
import { useEffect, useState } from 'react'
import { getExpLocalStorage, setExpLocalStorage, setLocalStorage } from '@/lib/localStorage'
import Link from 'next/link'


export default function Footer() {

    const { theme, screen, API, headers, privateKey, base_url_img } = useGlobalContext()
    const [config_web, setConfig_web] = useState(null)



    useEffect(() => {
        const Footerdata = async () => {
            // console.log('/api/config_web')
            const getdata = await AxiosGetData(API, '/api/config_web', headers, privateKey)

            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(getdata), privateKey).toString();
            setConfig_web(getdata)
            setExpLocalStorage('Config', encrypted, 4)
        }
        const configdata = getExpLocalStorage('Config')
        if (!configdata) {
            Footerdata()
        } else {
            const data = CryptoJS.AES.decrypt(configdata, privateKey).toString(CryptoJS.enc.Utf8);
            setConfig_web(JSON.parse(data))
        }
    }, [API, headers, privateKey])

    const footerData = [
        {
            title: 'บริการของเรา',
            items: [
                { text: 'วิธีการซื้ออีบุ๊ก', link: '/manual/buyebook' },
                { text: 'วิธีเติมเหรียญ / ระบบเหรียญ', link: '/manual/coinsystem' },
                // { text: 'คู่มือนักเขียน', link: '/manual/manual_writer' },
                { text: 'คำถามที่พบบ่อย (FAQ)', link: '/faq' }
            ],
        },
        {
            title: 'ข้อกำหนดและเงื่อนไข',
            items: [
                { text: 'นโยบายความเป็นส่วนตัว', link: '/privacy_policy' }, { text: 'ข้อกำหนดการใช้งาน', link: '/condition_terms' },
                { text: 'เงื่อนไขการลงทะเบียนนักเขียน', link: '/manual/manual_writer' }
            ],
        },
        {
            title: 'เกี่ยวกับเรา',
            items: [
                // {text:'เกี่ยวกับ EVE-EBOOK',link:'/about_us'}, 
                { text: 'ข่าวสาร/โปรโมชั่น', link: 'https://www.facebook.com/share/15wWnQqWGN/?mibextid=wwXIfr' }],
        },
        {
            title: 'ติดต่อเรา',
            items: [
                { text: '<p>บริษัท อีฟบุ๊ค จำกัด <br/> 9/70 หมู่ที่ 2 ต.คูคต <br/> อ.ลำลูกกา ปทุมธานี 12130</p>', link: null },

            ],
        },
    ];




    // จัดการรูป + link footer
    const iconSuffix = theme === 'light_theme' ? '-b' : '';
    const icons = [
        { key: 'link_fb', name: 'facebook' },
        { key: 'link_line', name: 'line' },
        { key: 'link_ig', name: 'ig' },
        { key: 'link_tiktok', name: 'tiktok' },
        { key: 'link_youtube', name: 'youtube' },
    ];

    return (

        <div className='footer '>
            {screen === 'desktop' ? <FooterDesktop data={footerData} /> : <FooterTablet data={footerData} />}

            <div className=' border-t text-primary border-[#E5E7EB] h-full w-full flex flex-col md:flex-row justify-between items-center gap-5 xl:px-[16%] px-[9%] pt-[2em]' >
                <div className='flex flex-col md:flex-row  items-center gap-[1em] md:gap-[2em]'>
                    {theme === 'light_theme' ? (
                        <Image src={FootLogoBlack} width={100} height={100} className="h-[90px]  col-span-2 justify-end" alt="EveEbook" />
                    ) : (
                        <Image src={FootLogo} width={100} height={100} className="h-[90px]  col-span-2 justify-end" alt="EveEbook" />
                    )
                    }
                    ดาวน์โหลดเพื่ออ่านบนแอปฯ

                    {config_web?.link_google && (
                        <Link href={config_web.link_google} target="_blank">
                            <Image
                                src={`${theme === 'light_theme' ? 'https://eve-image.eveebook.com/image.eveebook/footer/gg_li.png' : 'https://eve-image.eveebook.com/image.eveebook/footer/gg_bl.png'}`}
                                width={300}
                                height={300}
                                className="h-[45px] w-auto col-span-2 justify-end"
                                unoptimized
                                alt="GG"
                            />
                        </Link>
                    )}

                    {config_web?.link_ios && (
                        <Link href={config_web.link_ios} target="_blank">
                            <Image
                                src={`${theme === 'light_theme' ? 'https://eve-image.eveebook.com/image.eveebook/footer/apple_li.png' : 'https://eve-image.eveebook.com/image.eveebook/footer/apple_bl.png'}`}
                                width={300}
                                height={300}
                                className="h-[45px] w-auto col-span-2 justify-end"
                                unoptimized
                                alt="IOS"
                            />
                        </Link>
                    )}

                </div>


                <div className="flex gap-[32px]">
                    {icons.map(({ key, name }) =>
                        config_web?.[key] ? (
                            <Link key={name} href={config_web[key] || '#'} target="_blank">
                                <img src={`https://eve-image.eveebook.com/image.eveebook/footer/${name}${iconSuffix}.png`} alt={name} />
                            </Link>
                        ) : null
                    )}
                </div>

            </div>
            <div className='text-[12px] mt-[1em] col-span-12 text-[#9CA3AF] text-center pb-[2em]'>Copyright © 2025 EVEBOOK CO., LTD</div>
        </div>
    )
}

